import { http } from "./api-config";
import store from "../store";

const apiConfigClient = http(process.env.VUE_APP_NEWS_SERVICE)

export default {
    async getNewsListById(companyId) {
        try {
            let headers = {};
            if (store.state.variables.cashNewsList) {
                headers = { "isSilentAPI": true };
            }
            store.commit('variables/setCashNewsList', true)
            const res = await apiConfigClient.get(`newslist/${companyId}`, { headers })
            return res.data
        }
        catch (error) {
            console.log(error.response)
        }
    },
    async getNewsSettingById(companyId) {
        try {
            let headers = {};
            if (store.state.variables.cashNewsSetting) {
                headers = { "isSilentAPI": true };
            }
            store.commit('variables/setCashNewsSetting', true)
            const res = await apiConfigClient.get(`newssetting/${companyId}`, { headers })
            return res.data
        }
        catch (error) {
            console.log(error.response)
        }
    },
    async getAnnouncementList() {
        let headers = {};
        if (store.state.variables.cashAnnouncementList) {
            headers = { "isSilentAPI": true };
        }
        store.commit('variables/setCashAnnouncementList', true)
        const res = await apiConfigClient.get('announcement_list', { headers })
        return res.data.data
    },
    async getAnnouncementById(id) {
        const res = await apiConfigClient.get(`announcement/${id}`)
        return res.data.data
    },
    async createAnnouncement(data) {
        const res = await apiConfigClient.post('announcement', data)
        return res.data.data
    },
    async updateAnnouncement(data) {
        const res = await apiConfigClient.put('announcement', data)
        return res.data.data
    },
    async deleteAnnouncement(id) {
        const res = await apiConfigClient.delete(`announcement/${id}`)
        return res.data.data
    },
}